import React from "react";
import styled from "styled-components";

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt?: string;
    fallback?: string;
}

const ImageRoot = styled.img<ImageProps>`
    max-width: 100%;
    height: auto;
    display: block;
`;

export const Image: React.FC<ImageProps> = ({ src, alt, fallback, onError, ...props }) => {
    const [imgSrc, setImgSrc] = React.useState(src);

    React.useEffect(() => {
        setImgSrc(src);
    }, [src]);

    const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        if (fallback && imgSrc !== fallback) {
            setImgSrc(fallback);
        }
        onError?.(e);
    };

    return <ImageRoot src={imgSrc} alt={alt} onError={handleError} {...props} />;
};

export default Image;
